/**
 * Generic Profile Update Box localStorage utilities
 * Used for temporary dismissal of profile update prompt.
 */

export const PROFILE_UPDATE_BOX_DISMISSED_KEY = 'profile-update-box-dismissed'

export function setProfileUpdateBoxDismissed(): void {
  if (typeof window !== 'undefined') {
    localStorage.setItem(PROFILE_UPDATE_BOX_DISMISSED_KEY, 'true')
  }
}

export function removeProfileUpdateBoxDismissed(): void {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(PROFILE_UPDATE_BOX_DISMISSED_KEY)
  }
}
